// extracted by mini-css-extract-plugin
module.exports = {"fullScreenContainer":"ShareSession_fullScreenContainer__xIfFv","previewContainer":"ShareSession_previewContainer__2-8bs"};